import { nestServer } from "../axios";
/**
 * orval custom instance
 *
 * 기존 nestServer (lazy init) 인스턴스를 orval 생성 코드에서 사용할 수 있도록 래핑한다.
 * orval의 mutator로 설정하여 모든 생성 API 함수에서 이 인스턴스를 사용한다.
 */
export const customInstance = (config) => {
    return nestServer(config).then((response) => response.data);
};
export default customInstance;
